var map = {
	"./activity-bind.svg": "S9iH",
	"./activity-cart-black.svg": "8kDm",
	"./activity-coupon-bg-0.svg": "2QLe",
	"./activity-coupon-bg-1.svg": "m7Ix",
	"./activity-miaosha.svg": "sC/G",
	"./activity-pintuan.svg": "QQ4p",
	"./activity-type-miaosha.svg": "mmvT",
	"./activity-type-pintuan.svg": "Fwp4",
	"./activity-type-vip.svg": "QI9d",
	"./activity-type-zhekou.svg": "DijX",
	"./activity-vip.svg": "csuW",
	"./activity-zhekou.svg": "pQqI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1jJy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/activity nonrecursive \.svg$
// module id = 1jJy
// module chunks = 62